<template>
  <WCModal @dismiss="dismiss('Dismissed')">
    <WCModalBody>
      <div class="text-center" v-if="!receipt">
        {{ $t('receiptLoading') }}
      </div>
      <div v-if="receipt">
        <div class="d-flex justify-content-between align-items-start">
          <button @click="printReceipt" class="btn btn-link underline-link-from-center m-0">
            {{ $t('printReceipt') }}
          </button>
          <button type="button" class="close" @click="dismiss('cancel')" :aria-label="$t('close')">
            <!-- eslint-disable-next-line -->
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <WCCustomContent v-if="!loadFailedError && !loading" :content="receipt" />
      </div>
    </WCModalBody>
  </WCModal>
</template>

<script>
import axios from 'axios';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCCustomContent from '@/components/WCCustomContent/WCCustomContent.vue';

export default {
  components: { WCCustomContent, WCModal, WCModalBody },
  props: {
    scancode: {
      type: String,
    },
  },
  mixins: [ModalMixin],
  async created() {
    this.loading = true;
    this.loadFailedError = null;

    try {
      const response = await axios.get(`/api/me/orders/${this.scancode}/receipt`);
      this.receipt = response.data.data;
    } catch (error) {
      this.loading = false;
      this.loadFailedError = error;
      console.error(error);
    }

    this.loading = false;
  },
  data() {
    return {
      loading: false,
      loadFailedError: null,
      receipt: null,
    };
  },
  methods: {
    printReceipt() {
      const popupWin = window.open('', '_blank', 'width=640,height=800');
      popupWin.document.open();
      popupWin.document.write(`<html><body onload="window.print()">${this.receipt}</body></html>`);
      popupWin.document.close();
    },
  },
};
</script>
